import React from 'react';
import { useFM } from '@/context/FMContext';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

/**
 * GymSelector - dropdown to switch between FM's assigned gyms.
 * Appears in the FM layout header on every FM page.
 */
export default function GymSelector() {
  const { selectedGymId, setSelectedGymId, gyms, loading } = useFM();

  if (loading) {
    return (
      <div className="w-40 h-9 bg-slate-100 rounded-md animate-pulse" />
    );
  }

  if (!gyms || gyms.length === 0) {
    return (
      <span className="text-sm text-slate-400">No gyms assigned</span>
    );
  }

  return (
    <Select value={selectedGymId || ''} onValueChange={setSelectedGymId}>
      <SelectTrigger className="w-48 text-sm">
        <SelectValue placeholder="Select gym" />
      </SelectTrigger>
      <SelectContent>
        {gyms.map((gym) => {
          const id = gym.gym_id || gym._id;
          return (
            <SelectItem key={id} value={id}>
              <div className="flex items-center gap-2">
                <span
                  className={`w-2 h-2 rounded-full ${
                    gym.status === 'GREEN' ? 'bg-green-500' :
                    gym.status === 'YELLOW' ? 'bg-yellow-500' :
                    gym.status === 'RED' ? 'bg-red-500' :
                    'bg-slate-300'
                  }`}
                />
                <span className="truncate">{gym.name || gym.gym_name || id}</span>
              </div>
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
}
